import styled from 'styled-components'

type FullWidthProps = { fullWidth: boolean }

export const Wrapper = styled.div<FullWidthProps>`
  background: var(--brand-primary);
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: ${({ fullWidth }) => (fullWidth ? '530px' : '600px')};
  position: relative;
  overflow: hidden;
  border-radius: ${({ fullWidth }) => (fullWidth ? '0' : '20px')};

  & > button {
    width: fit-content;
    background: var(--brand-secondary);
    color: white;
    border: 1px solid var(--brand-secondary);

    &:hover {
      background: var(--brand-secondary);
    }
  }

  @media (max-width: 1100px) {
    height: auto;
  }
`
export const Content = styled.div<FullWidthProps>`
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: row;
  align-items: ${({ fullWidth }) => (fullWidth ? 'center' : 'flex-end')};
  justify-content: space-around;
  gap: 15px;
  margin: 0 auto;
  box-sizing: border-box;
  margin: 0 auto;
  padding: ${({ fullWidth }) => (fullWidth ? '50px 0 50px 100px' : '100px 0 100px 100px')};

  @media (max-width: 1400px) {
    padding: 100px 35px;
  }

  @media (max-width: 1100px) {
    gap: 40px;
    padding: 35px 25px;
    width: 100%;
    position: relative;
    z-index: 2;
    flex-direction: column-reverse;
  }

  @media (max-width: 900px) {
    gap: 10px;
  }
`
export const Graphic = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 80%;
  height: 80%;

  svg {
    width: 100%;
    height: 100%;
  }

  @media (max-width: 1000px) {
    width: 180%;
    top: 10%;
  }
`
export const ImageWrapper = styled.div`
  height: 100%;
  box-sizing: border-box;
  width: 55%;
  display: flex;
  justify-content: center;

  @media (max-width: 1100px) {
    width: 100%;
  }
  @media (min-width: 900px) and (max-width: 1100px) {
    height: 500px;
  }
  @media (max-width: 900px) {
    width: 100%;
    height: 320px;
  }
`

export const AusImage = styled.div<{ imageUrl: string; maskImageUrl: string }>`
  height: 100%;
  width: 100%;
  position: relative;
  background-image: url('${({ imageUrl }) => imageUrl}');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  -webkit-mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-image: url('${({ maskImageUrl }) => maskImageUrl}');
  -webkit-mask-position: center;
`

export const Text = styled.div<FullWidthProps>`
  display: flex;
  width: ${({ fullWidth }) => (fullWidth ? '500px' : '45%')};
  min-width: 350px;
  flex-direction: column;
  justify-content: center;
  padding-bottom: ${({ fullWidth }) => (fullWidth ? '0' : '100px')};

  button {
    width: max-content;
  }

  @media (max-width: 1100px) {
    width: 100%;
    padding-bottom: 0;
    min-width: unset;
  }
`
